/**
 * Copyright (c) Microsoft. All rights reserved.
 */

// tslint:disable:no-any
// tslint:disable:export-name

export function toJson(obj: any): string {
    try {
        return JSON.stringify(obj);
    } catch (error) {
        return `Unable to serialize object of type ${typeof obj}`;
    }
}

/**
 * Simplify calculation of time intervals
 */
export class Timespan {
    private start: number;

    constructor() {
        this.start = Date.now();
    }

    /**
     * Returns number of milliseconds from start
     */
    public get duration(): number {
        return Date.now() - this.start;
    }

    /**
     * Returns start time
     */
    public get startTime() {
        return this.start;
    }

    /**
     * Reset start of interval to current timestamp
     */
    public reset() {
        this.start = Date.now();
    }
}



// WEBPACK FOOTER //
// ./lib_temp/Common.ts